import { render, staticRenderFns } from "./towbootm.vue?vue&type=template&id=94b08c80&scoped=true&"
import script from "./towbootm.vue?vue&type=script&lang=js&"
export * from "./towbootm.vue?vue&type=script&lang=js&"
import style0 from "./towbootm.vue?vue&type=style&index=0&id=94b08c80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b08c80",
  null
  
)

export default component.exports